import { classNames } from "primereact/utils";
import PropTypes from 'prop-types';
import "./DeviceMetricCard.scss";
import blueIcon from '../../assets/images/metric-icon-blue.svg';
import greenIcon from '../../assets/images/metric-icon-green.svg';
import redIcon from '../../assets/images/metric-icon-red.svg';
import orangeIcon from '../../assets/images/metric-icon-orange.svg';
import yellowIcon from '../../assets/images/metric-icon-yellow.svg';
import grayIcon from '../../assets/images/metric-icon-gray.svg';
import arrowRight from '../../assets/images/arrow_right.svg';
import { useContext, useEffect, useMemo, useState, useRef } from "react";
import { DeviceService } from "../../service/DeviceService";
import { useTranslation } from "react-i18next";
import LoadingSpinner from "../loadingoverlay/LoadingSpinner";
import { useLocation, useNavigate } from "react-router-dom";
import { DeviceMetricsContext } from "../../context/DeviceMetricsContext";

const DeviceMetricCard = ({className, healthState, ...props}) => {
    const { t } = useTranslation();
    const { refreshTimestamp } = useContext(DeviceMetricsContext);
    const [metric, setMetric] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const isMounted = useRef(false);
    const config = useMemo(() => ({
        ALL: {
            icon: blueIcon,
            label: 'metrics.all.label',
            variant: 'blue',
        },
        UNASSIGNED: {
            icon: yellowIcon,
            label: 'metrics.unassigned.label',
            variant: 'yellow',
        },
        ON_LINE: {
            icon: greenIcon,
            label: 'metrics.on-line.label',
            variant: 'green',
        },
        OFF_LINE: {
            icon: redIcon,
            label: 'metrics.off-line.label',
            variant: 'red',
        },
        UNCONFIGURED: {
            icon: grayIcon,
            label: 'metrics.unconfigured.label',
            variant: 'gray',
        },
        WITH_ERROR: {
            icon: orangeIcon,
            label: 'metrics.with-errors.label',
            variant: 'orange',
        },
        INACTIVE: {
            icon: redIcon,
            label: 'metrics.inactive.label',
            variant: 'red',
        }        
    }), []);

    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        isMounted.current = true;
        
        fetchMetric(true);        
        const intervalId = setInterval(() => {
            if (isMounted.current) {
                fetchMetric(false);
            }
        }, 125000); // 125 seconds

        return () => {
            isMounted.current = false;
            clearInterval(intervalId);
        };
    }, [healthState]);

    // Odświeżaj dane przy zmianie URL
    useEffect(() => {
        if (isMounted.current && location.pathname !== '/') {
            fetchMetric(false);
        }
    }, [location.pathname]);

    // Odświeżaj metryki przy zmianie refreshTimestamp (aktywacja/deaktywacja urządzenia)
    useEffect(() => {
        if (isMounted.current && refreshTimestamp) {
            fetchMetric(false);
        }
    }, [refreshTimestamp]);

    const fetchMetric = async (showLoading = true) => {
        if (showLoading) {
            setIsLoading(true);
        }
        try {
            const metric = await DeviceService.getDevicesMetric(healthState == 'ALL' ? null : healthState);
            if (isMounted.current) {
                setMetric(metric);
            }
        } catch (error) {
            // console.log('DeviceService::getDevicesMetric err', error); // Usunięte dla wydajności
            if (isMounted.current) {
                setMetric(null);
            }
        } finally {
            if (showLoading) {
                setIsLoading(false);
            }
        }
    };

    return (
        <div className={classNames('metric-card ', `variant-${config[healthState]?.variant}`, className)} 
            onClick={() => navigate(`/devices?healthState=${healthState}`)}>
            <div className='metric-card-content'>                
                <div className='metric-card-content2'>
                    <img src={config[healthState]?.icon} />                    
                    <div className="label">{t(config[healthState]?.label)}</div>
                    {isLoading ? <LoadingSpinner size="1rem" /> : (
                    <div className={classNames('badge', `variant-${config[healthState]?.variant}`)}>
                        <div className="badge-text">{metric?.count || 0}</div>
                    </div>)}
                </div>
            </div>
            <img className="keyboard-arrow-up cursor-pointer" src={arrowRight} />
            {/* <div className='flex justify-content-end'>
            </div> */}
            
        </div>
  );
}


export default DeviceMetricCard;

DeviceMetricCard.propTypes = {
    className: PropTypes.string,
    healthState: PropTypes.oneOf([
        'ALL',
        'UNASSIGNED', 
        'ON_LINE',
        'OFF_LINE',
        'UNCONFIGURED',
        'WITH_ERROR',
        'INACTIVE'
    ]).isRequired
};